import { useEffect, useMemo, useRef, useState } from "react";

const CategoryDropdown = ({
  value = "",
  options = [],
  onChange,
  placeholder = "All Categories",
  className = "",
  buttonClassName = "",
  menuClassName = "",
  style = {},
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selected = useMemo(() => {
    const selectedOption = options?.find(
      (item) => String(item?.id ?? "") === String(value ?? ""),
    );

    return selectedOption?.categoryName || placeholder;
  }, [options, placeholder, value]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleSelect = (nextValue) => {
    onChange?.(nextValue);
    setOpen(false);
  };

  return (
    <div ref={dropdownRef} className={`position-relative ${className}`.trim()}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        className={`d-flex align-items-center justify-content-between ct_category_dropdown_trigger ${buttonClassName}`.trim()}
        style={style}
      >
        <span className={`text-truncate ${value ? "" : "opacity-75"}`.trim()}>
          {selected}
        </span>
        <i class="fa-solid fa-angle-down ms-1"></i>
      </div>

      {open && (
        <div
          className={`ct_custom_select_option_drop mt-1 ${menuClassName}`.trim()}
        >
          <p
            onClick={() => handleSelect("")}
            className={`px-4 py-2 cursor-pointer ct_custom_option mb-0 ${!value ? "ct_active" : ""}`.trim()}
          >
            {placeholder}
          </p>

          {options?.map((item) => (
            <p
              key={item?.id}
              onClick={() => handleSelect(item?.id)}
              className={`px-4 py-2 cursor-pointer ct_custom_option mb-0 ${String(item?.id ?? "") === String(value ?? "") ? "ct_active" : ""}`.trim()}
            >
              {item?.categoryName || ""}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;
